import { render, staticRenderFns } from "./my-store.vue?vue&type=template&id=2c8008e4&"
import script from "./my-store.vue?vue&type=script&lang=js&"
export * from "./my-store.vue?vue&type=script&lang=js&"
import style0 from "./my-store.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports